import { Tag } from 'features/common/types';

// The API returns tag IDs as `id` from some endpoints and `ID` from others.
// This normalises both shapes to a single numeric ID.
export const getTagId = (tag: Tag): number => (tag.id ?? tag.ID) as number;
